module.exports = __webpack_public_path__ + "img/weddings_03_V.02a3e52f.webp";